import { render, staticRenderFns } from "./evidenceAndTort.vue?vue&type=template&id=7750f8ba&scoped=true&"
import script from "./evidenceAndTort.vue?vue&type=script&lang=js&"
export * from "./evidenceAndTort.vue?vue&type=script&lang=js&"
import style0 from "./evidenceAndTort.vue?vue&type=style&index=0&id=7750f8ba&prod&lang=less&"
import style1 from "./evidenceAndTort.vue?vue&type=style&index=1&id=7750f8ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7750f8ba",
  null
  
)

export default component.exports